export default {
  //存储数据
  state: {
    message: "",
    msgContent:'',//消息数据
  },
    getters: {
        msgContent:state=>state.msgContent,
    },
  //调用方法
  mutations: {
    getMessage(state, data) {
      state.message = data;
    },
      SETMSGContent:(state, obj)=>{
          state.msgContent = obj
      }
  },
  actions: {
      setMsgContent({commit},obj){
          commit("SETMSGContent", obj)
      }
  }
};
